import axiosIns from '@axios'

const $http = axiosIns

// Change Requests
export const $getChangeRequests = async (filters: object, config: object = {}) => {
  return $http.get('change-requests/', { params: filters, ...config  })
}

export const $getChangeRequest = async (id: number | string, payload: object) => {
  return $http.get(`change-requests/${id}/`, { params: payload })
}

export const $getChangeRequestOptions = async () => {
  return $http.options('change-requests/')
}

export const $updateChangeRequest = async (id: number | string, payload: object) => {
  return $http.patch(`change-requests/${id}/`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $createChangeRequest = async (payload: object) => {
  return await $http.post('change-requests/', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $duplicateChangeRequest = async (payload: object) => {
  return $http.post('duplicate-change-request/', payload)
}

// Change Request Action Required
export const $getChangeRequestActionRequiredItems = async (filters: object) => {
  return $http.get('get-change-request-action-required-items/', { params: filters })
}

//Change Request All Objects
export const $getChangeRequestAllObjects = async (filters: object, config: object = {}) => {
  return $http.get('get-change-request-all-objects/', { params: filters, ...config })
}

// Multiple CR Updates
export const $multipleUpdateChangeRequestStatus = async (payload: object) => {
  return await $http.post('multiple-update-change-request-status/', payload)
}

export const $multipleUpdateChangeRequestAssignedTo = async (payload: object) => {
  return await $http.post('multiple-update-change-request-assigned-to/', payload)
}

export const $multipleUpdateChangeRequestPriority = async (payload: object) => {
  return await $http.post('multiple-update-change-request-priority/', payload)
}

// Change Request Comments
export const $createChangeRequestComment = async (payload: object) => {
  return await $http.post('change-request-comments/', payload)
}

export const $updateChangeRequestComment = async (id: number | string, payload: object) => {
  return await $http.patch(`change-request-comments/${id}/`, payload)
}

export const $deleteChangeRequestComment = async (id: number | string) => {
  return await $http.delete(`change-request-comments/${id}/`)
}

export const $getChangeRequestComment = async (id: number | string) => {
  return await $http.get(`change-request-comments/${id}/`)
}

export const $getChangeRequestComments = async (params: object) => {
  return await $http.get('change-request-comments/', { params: params })
}

// Change Request Approvals
export const $getChangeRequestApprovals = async (filters: object) => {
  return $http.get('change-request-approvals/', { params: filters })
}

export const $getChangeRequestApproval = async (id: number | string) => {
  return $http.get(`change-request-approvals/${id}/`)
}

export const $getChangeRequestApprovalOptions = async () => {
  return $http.options('change-request-approvals/')
}

export const $updateChangeRequestApproval = async (id: number | string, payload: object) => {
  return $http.patch(`change-request-approvals/${id}/`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $createChangeRequestApproval = async (payload: object) => {
  return await $http.post('change-request-approvals/', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $deleteChangeRequestApproval = async (id: number | string) => {
  return await $http.delete(`change-request-approvals/${id}/`)
}

// Change Request Approval Comments
export const $createChangeRequestApprovalComment = async (payload: object) => {
  return await $http.post('change-request-approval-comments/', payload)
}

export const $updateChangeRequestApprovalComment = async (id: number | string, payload: object) => {
  return await $http.patch(`change-request-approval-comments/${id}/`, payload)
}

export const $deleteChangeRequestApprovalComment = async (id: number | string) => {
  return await $http.delete(`change-request-approval-comments/${id}/`)
}

export const $getChangeRequestApprovalComment = async (id: number | string) => {
  return await $http.get(`change-request-approval-comments/${id}/`)
}

export const $getChangeRequestApprovalComments = async (params: object) => {
  return await $http.get('change-request-approval-comments/', { params: params })
}

// Change Request Subtasks
export const $getChangeRequestSubtasks = async (filters: object) => {
  return $http.get('change-request-subtasks/', { params: filters })
}

export const $getChangeRequestSubtask = async (id: number | string) => {
  return $http.get(`change-request-subtasks/${id}/`)
}

export const $getChangeRequestSubtaskOptions = async () => {
  return $http.options('change-request-subtasks/')
}

export const $updateChangeRequestSubtask = async (id: number | string, payload: object) => {
  return $http.patch(`change-request-subtasks/${id}/`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $createChangeRequestSubtask = async (payload: object) => {
  return await $http.post('change-request-subtasks/', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const $deleteChangeRequestSubtask = async (id: number | string) => {
  return await $http.delete(`change-request-subtasks/${id}/`)
}

export const $duplicateChangeRequestSubtask = async (payload: object) => {
  return $http.post('duplicate-change-request-subtask/', payload)
}

// Change Request Subtask Comments
export const $createChangeRequestSubtaskComment = async (payload: object) => {
  return await $http.post('change-request-subtask-comments/', payload)
}

export const $updateChangeRequestSubtaskComment = async (id: number | string, payload: object) => {
  return await $http.patch(`change-request-subtask-comments/${id}/`, payload)
}

export const $deleteChangeRequestSubtaskComment = async (id: number | string) => {
  return await $http.delete(`change-request-subtask-comments/${id}/`)
}

export const $getChangeRequestSubtaskComment = async (id: number | string) => {
  return await $http.get(`change-request-subtask-comments/${id}/`)
}

export const $getChangeRequestSubtaskComments = async (params: object) => {
  return await $http.get('change-request-subtask-comments/', { params: params })
}

// Change Request Global Options
export const $getChangeRequestGlobalOptions = async (filters: object) => {
  return await $http.get('change-request-global-options/', { params: filters })
}

// Export Excel Change Requests
export const $exportExcelChangeRequests = async (payload: object) => {
  return await $http.post('/export-excel-change-requests/', payload)
}

// --- CR Attachment ---
export const $getCrFileAttachment = async (id: number | string) => {
  return await $http.get(`change-request-file-attachments/${id}/`)

}

// CR Attachment Annotations
export const $crFileAttachmentAnnotationList = async (params: object) => {
  return await $http.get('change-request-file-attachment-annotations/', { params: params })
}

export const $crFileAttachmentAnnotationCreate = async (payload: object) => {
  return await $http.post('change-request-file-attachment-annotations/', payload)
}

export const $crFileAttachmentAnnotationUpdate = async (id: number, payload: object) => {
  return await $http.patch(`change-request-file-attachment-annotations/${id}/`, payload)
}

export const $crFileAttachmentAnnotationDelete = async (id: number) => {
  return await $http.delete(`change-request-file-attachment-annotations/${id}/`)
}

// CR Attachment Annotation Comments
export const $crFileAttachmentAnnotationCommentCreate = async (payload: object) => {
  return await $http.post('change-request-file-attachment-annotation-comments/', payload)
}

export const $crFileAttachmentAnnotationCommentDelete = async (id: number) => {
  return await $http.delete(`change-request-file-attachment-annotation-comments/${id}/`)
}

// --- CR Approval Attachment ---
export const $getCrApprovalFileAttachment = async (id: number | string) => {
  return await $http.get(`change-request-approval-file-attachments/${id}/`)

}

// CR Approval Attachment Annotations
export const $crApprovalFileAttachmentAnnotationList = async (params: object) => {
  return await $http.get('change-request-approval-file-attachment-annotations/', { params: params })
}

export const $crApprovalFileAttachmentAnnotationCreate = async (payload: object) => {
  return await $http.post('change-request-approval-file-attachment-annotations/', payload)
}

export const $crApprovalFileAttachmentAnnotationUpdate = async (id: number, payload: object) => {
  return await $http.patch(`change-request-approval-file-attachment-annotations/${id}/`, payload)
}

export const $crApprovalFileAttachmentAnnotationDelete = async (id: number) => {
  return await $http.delete(`change-request-approval-file-attachment-annotations/${id}/`)
}

// CR Approval Attachment Annotation Comments
export const $crApprovalFileAttachmentAnnotationCommentCreate = async (payload: object) => {
  return await $http.post('change-request-approval-file-attachment-annotation-comments/', payload)
}

export const $crApprovalFileAttachmentAnnotationCommentDelete = async (id: number) => {
  return await $http.delete(`change-request-approval-file-attachment-annotation-comments/${id}/`)
}

// --- CR Subtask Attachment ---
export const $getCrSubtaskFileAttachment = async (id: number | string) => {
  return await $http.get(`change-request-subtask-file-attachments/${id}/`)

}

// CR Subtask Attachment Annotations
export const $crSubtaskFileAttachmentAnnotationList = async (params: object) => {
  return await $http.get('change-request-subtask-file-attachment-annotations/', { params: params })
}

export const $crSubtaskFileAttachmentAnnotationCreate = async (payload: object) => {
  return await $http.post('change-request-subtask-file-attachment-annotations/', payload)
}

export const $crSubtaskFileAttachmentAnnotationUpdate = async (id: number, payload: object) => {
  return await $http.patch(`change-request-subtask-file-attachment-annotations/${id}/`, payload)
}

export const $crSubtaskFileAttachmentAnnotationDelete = async (id: number) => {
  return await $http.delete(`change-request-subtask-file-attachment-annotations/${id}/`)
}

// CR Subtask Attachment Annotation Comments
export const $crSubtaskFileAttachmentAnnotationCommentCreate = async (payload: object) => {
  return await $http.post('change-request-subtask-file-attachment-annotation-comments/', payload)
}

export const $crSubtaskFileAttachmentAnnotationCommentDelete = async (id: number) => {
  return await $http.delete(`change-request-subtask-file-attachment-annotation-comments/${id}/`)
}
